import { Stack, styled } from '@mui/material';

import { SpecLabel, SpecValue } from './AdvertisingSpaceDetailsInfo.styles';

export const RentCard = styled(Stack)(() => ({
  width: '100%',
  padding: '1.5rem',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1rem',
  borderRadius: '1rem',
  backgroundColor: '#FEFEFE',
  boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.15)',
}));

export const PriceBlock = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '0.5rem',
}));

export const PriceRow = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '0.5rem',
}));

export const PriceFromLabel = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  lineHeight: '130%',
  color: theme.palette.grey[950],
}));

export const PriceValue = styled('div')(({ theme }) => ({
  fontSize: '1.875rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.accent.main,
}));

export const PriceSuffix = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '130%',
  color: theme.palette.grey[950],
}));

export const PriceDisclaimer = styled('p')(({ theme }) => ({
  margin: 0,
  alignSelf: 'stretch',
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: '100%',
  color: theme.palette.grey[600],
  width: '100%',
}));

export const AvailabilityRow = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.25rem',
  width: '100%',
}));

export const AvailabilityDot = styled('span')(({ theme }) => ({
  width: 7,
  height: 7,
  borderRadius: '50%',
  backgroundColor: theme.palette.green[600],
  flexShrink: 0,
}));

export const AvailabilityText = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: '100%',
  color: theme.palette.green[700],
}));

export const DateGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  width: '100%',
  borderRadius: '0.75rem',
  overflow: 'hidden',
}));

export const DateBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '0.5rem',
  color: theme.palette.grey[900],
  minWidth: 0,
}));

export const DateBoxStart = styled(DateBox)(({ theme }) => ({
  borderTopLeftRadius: '0.75rem',
  boxShadow: `inset 0 0 0 1px ${theme.palette.grey[200]}`,
}));

export const DateBoxEnd = styled(DateBox)(({ theme }) => ({
  borderTopRightRadius: '0.75rem',
  boxShadow: [
    `inset 0 1px 0 0 ${theme.palette.grey[200]}`,
    `inset 0 -1px 0 0 ${theme.palette.grey[200]}`,
    `inset -1px 0 0 0 ${theme.palette.grey[200]}`,
  ].join(', '),
}));

export const DateBoxLabel = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.625rem',
  fontWeight: 400,
  textTransform: 'uppercase',
  lineHeight: '100%',
  color: theme.palette.grey[900],
}));

export const DateBoxValue = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '130%',
  color: theme.palette.grey[900],
}));

export const DurationLabelGroup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));

export const DurationRow = styled('div')(({ theme }) => ({
  gridColumn: '1 / span 2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.5rem',
  borderBottomLeftRadius: '0.75rem',
  borderBottomRightRadius: '0.75rem',
  boxShadow: [
    `inset 1px 0 0 0 ${theme.palette.grey[200]}`,
    `inset -1px 0 0 0 ${theme.palette.grey[200]}`,
    `inset 0 -1px 0 0 ${theme.palette.grey[200]}`,
  ].join(', '),
}));

export const BreakdownSection = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const BreakdownValue = styled(SpecValue)(() => ({
  fontSize: '0.875rem',
  lineHeight: '130%',
}));

export const BreakdownTotalLabel = styled(SpecLabel)(({ theme }) => ({
  color: theme.palette.grey[950],
}));
